module.exports = __webpack_public_path__ + "img/question-women.6be8f101.png";